<!--
 * @Author:
 * @Description: 照明设备详情
-->
<template>
  <CockpitDialog
    class="left-520px top-300px text-white !text-opacity-80"
    title="照明设备详情"
    @close="close"
  >
    <el-form label-width="120px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="设备地址：">
            <el-input
              v-model="formData.addr"
              placeholder="请输入"
              size="small"
              readonly
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备名称：">
            <el-input
              v-model="formData.devName"
              placeholder="请输入"
              size="small"
              readonly
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备网关：">
            <el-input
              v-model="formData.gwName"
              placeholder="请输入"
              size="small"
              readonly
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备类型：">
            <el-input
              v-model="formData.devTypeName"
              placeholder="请输入"
              size="small"
              readonly
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="在线状态：">
            <el-input
              v-model="formData.onlineStateName"
              placeholder="请输入"
              size="small"
              readonly
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="额定功率：">
            <el-input
              v-model="formData.devPower"
              placeholder="请输入"
              size="small"
              readonly
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="设备状态：">
            <el-switch
              v-model="formData.onlineStateName"
              active-color="#2ce1d9"
              inactive-color="#bcbaba"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <div class="relative">
      <DiyButtonGroup
        class="my-10px !text-14px"
        @button-click="buttonClick"
        :value="btnValue"
        :textSize="'14px'"
        :list="['设备状态', '电量', '功率', '功率因数', '视在功率']"
      ></DiyButtonGroup>
      <el-select
        class="absolute right-0 top-0"
        v-model="search.timeType"
        placeholder="故障等级"
        size="small"
        clearable
      >
        <el-option
          v-for="(item, index) in timeList"
          :key="index"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="h-200px">
      <v-chart :options="chartOptions" autoresize class="w-full h-full" ref="energyTrend"></v-chart>
    </div> -->
  </CockpitDialog>
</template>

<script>
import { LightingDeviceApi } from '@wiz-api/huizhou2-business'
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import DiyButtonGroup from '../../../../cockpit-huizhou/components/global/DiyButtonGroup'

const lightingDeviceApi = new LightingDeviceApi()
export default {
  name: 'alarmDetailDialog',
  components: {
    CockpitDialog,
    DiyButtonGroup,
  },
  props: {
    propsData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formData: {},
      btnValue: '设备状态',
      search: {
        timeType: 0,
      },
      timeList: [
        { label: '最近30分钟', value: 0 },
        { label: '最近6小时', value: 1 },
        { label: '最近1天', value: 2 },
        { label: '最近7天', value: 3 },
      ],
      chartOptions: {
        grid: {
          top: 40,
          left: 40,
          right: 10,
          bottom: 30,
        },
        legend: {
          show: true,
          data: ['电量'],
          textStyle: {
            color: 'rgba(255,255,255, 0.6)',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        color: ['#04ffd0'],
        xAxis: {
          type: 'category',
          data: [
            '1:00',
            '2:00',
            '3:00',
            '4:00',
            '5:00',
            '6:00',
            '7:00',
            '8:00',
            '9:00',
            '10:00',
            '11:00',
            '12:00',
          ],
          axisLabel: {
            color: 'rgba(255,255,255,0.6)',
            fontSize: 12,
            interval: 0,
            rotate: 30,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(255,255,255,0.6)',
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.1)',
            },
          },
        },
        series: [
          {
            name: '电量',
            data: [10, 20, 30, 60, 0, 0, 130, 10, 100, 0, 80, 0],
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 5,
            showSymbol: false,
            areaStyle: {
              normal: {
                color: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(0, 255, 207, 0.4)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(17, 70, 139, 0.01)',
                    },
                  ],
                },
              },
            },
          },
        ],
      },
    }
  },
  watch: {
    propsData: {
      deep: true,
      immediate: true,
      handler(val) {
        val.onlineStateName = val.onlineState === 1 ? '在线' : '离线'
        let devTypeName = ''
        switch (val.devType) {
          case 12:
            devTypeName = '灯'
            break
          case 13:
            devTypeName = '光感传感器'
            break
          case 14:
            devTypeName = '微波传感器'
            break
          case 15:
            devTypeName = '回路'
            break
          default:
            break
        }
        val.devTypeName = devTypeName
        this.formData = val
      },
    },
  },
  created() {
    this.getChartData()
  },
  methods: {
    // 页签点击
    buttonClick(val) {
      this.btnValue = val
      this.getChartData()
    },
    close() {
      this.$emit('refresh', false)
    },
    // 获取设备图表数据
    async getChartData() {
      let type = 0
      switch (this.btnValue) {
        case '设备状态':
          type = 0
          break
        case '电量':
          type = 1
          break
        case '功率':
          type = 2
          break
        case '功率因数':
          type = 3
          break
        case '视在功率':
          type = 4
          break
        default:
          break
      }
      this.search.type = type
      const [err, res] = await lightingDeviceApi.lightingDeviceReport({
        body: {
          type,
          devAddr: this.formData.addr,
          timeType: this.search.timeType,
        },
      })
      if (!err) {
        this.chartOptions.series[0].data = res.count
        this.chartOptions.xAxis.data = res.time
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
